var map = {
	"./Sa01.jpg": 12572,
	"./Sa02.jpg": 85505,
	"./Sa03.jpg": 49060,
	"./Sa04.jpg": 78857,
	"./Sa05.jpg": 15321,
	"./Sa06.jpg": 136,
	"./Tvu12.jpg": 20145,
	"./Tvu33.jpg": 15968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32222;